// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import {
    Box, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography
} from '@mui/material';

// TODO: Import MUI icon

// TODO: Import context

// TODO: Import custom component
import { Context, fetchData } from '../../Common/Context';
import { Text } from '../../Common/Text';

const TableData = ({ selectedYear }) => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component TableData Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define Imperative Handle

    // TODO: Define variable
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState([]);

    // TODO: Define event

    React.useEffect(() => {
        if (selectedYear) {
            setLoading(true);
            const formData = new FormData();
            formData.append('action', 'ACH_AwardsExternal_GetData');
            formData.append('year', selectedYear);
            fetchData(
                formData,
                (result) => {
                    setData(result);
                    setLoading(false);
                }
            )
        }
    }, [selectedYear]);

    // TODO: Return component
    const RenderDomain = ({ domain }) => (
        <Box sx={{ my: 2 }}>
            <Paper>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" colSpan={3} sx={{ backgroundColor: 'primary.main', color: 'white' }}>
                                    <Typography sx={{ fontWeight: 'bold' }} variant="h6">{data[domain][0].CName}</Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="center">
                                    {Text.Achievements.AwardsExternal.Organizer[context.language]}
                                </TableCell>
                                <TableCell align="center">
                                    {Text.Achievements.AwardsExternal.Items[context.language]}
                                </TableCell>
                                {/*<TableCell align="center" sx={{ minWidth: '120px' }}>
                                    {Text.Achievements.AwardsExternal.AwardDate[context.language]}
                                </TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data[domain].map((row, i) => (<RenderTableRow key={i} row={row} />))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );

    const RenderTableRow = ({ row }) => (
        <TableRow hover>
            <TableCell>
                <Typography dangerouslySetInnerHTML={{ __html: row.Organizer }} variant="body1" />
            </TableCell>
            <TableCell>
                <Typography dangerouslySetInnerHTML={{ __html: row.Item }} variant="body1" />
            </TableCell>
            {/*<TableCell>
                <Typography dangerouslySetInnerHTML={{ __html: row.DAward }} variant="body1" />
            </TableCell>*/}
        </TableRow>
    )

    const Table2024 = () => (
        <Paper sx={{ mt: 2 }}>
            <TableContainer>
                <Table cellspacing="0" cellpadding="0">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>　</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>舉行日期</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>主辦機構</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>比賽項目</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>學生姓名</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>名次</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>智能範疇</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableRow>
                        <TableCell rowspan="2">1</TableCell>
                        <TableCell rowspan="2">8月/2024</TableCell>
                        <TableCell rowspan="2">西貢文化中心<br />
                            社區發展基金會<br />
                            有限公司、西貢區校長會、友凝</TableCell>
                        <TableCell rowspan="2">第二十三屆西貢區傑出學生選舉</TableCell>
                        <TableCell>1A 陳嘉齊</TableCell>
                        <TableCell> 十大傑出學生優勝盃 </TableCell>
                        <TableCell rowspan="2">多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3B張森蕙、5A陳榮錄、5A孫暉喬</TableCell>
                        <TableCell>傑出學生嘉許狀 </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">2</TableCell>
                        <TableCell rowspan="2">8月/2024</TableCell>
                        <TableCell rowspan="2">香港旅遊事務署及香港青年協會</TableCell>
                        <TableCell rowspan="2">香港青年大使計劃</TableCell>
                        <TableCell>6A 黃悅頤、6E    林子樂</TableCell>
                        <TableCell>金章</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6A 李子苗</TableCell>
                        <TableCell>銀章、傑出計劃年獎</TableCell>
                        <TableCell rowspan="2">邏輯數學智能、空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3</TableCell>
                        <TableCell>3/8/2024</TableCell>
                        <TableCell>香港高等教育科技學院(THEi)</TableCell>
                        <TableCell rowspan="2">THEi    BIM比賽2024：將數碼建築及設備工程帶入校園</TableCell>
                        <TableCell> 4B馬梓唐、4B周靈兒、4C黎嘉善</TableCell>
                        <TableCell>二等獎 Bronze Award</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4</TableCell>
                        <TableCell>9月</TableCell>
                        <TableCell>中國民政部</TableCell>
                        <TableCell>2B    陳莉欣、3A 鄭盈、3B 鍾葦彤、4B 陳姿霖</TableCell>
                        <TableCell>全國青少年茶藝師證書</TableCell>
                        <TableCell>內省智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5</TableCell>
                        <TableCell>6/7/2024</TableCell>
                        <TableCell>青年學院</TableCell>
                        <TableCell>校際室內拉機邀請賽 2024</TableCell>
                        <TableCell>3B林廷軒</TableCell>
                        <TableCell>男子初中組 300米第8名</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">6</TableCell>
                        <TableCell rowspan="3">21/7/2024</TableCell>
                        <TableCell rowspan="3">沙田體育會</TableCell>
                        <TableCell rowspan="3">新界區室內三項鐵人賽    2024</TableCell>
                        <TableCell>3C陳荔瑩</TableCell>
                        <TableCell>女子個人全港中學生組殿軍</TableCell>
                        <TableCell rowspan="3">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5E李婥僑</TableCell>
                        <TableCell>女子個人全港中學生組第5名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3C陳荔瑩、5E李婥僑</TableCell>
                        <TableCell>隊際全港中學生女子組殿軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>7</TableCell>
                        <TableCell>31/8/2024</TableCell>
                        <TableCell>Hong    Kong Academy of Ice Hockey</TableCell>
                        <TableCell>2024    Summer Amateur Hockey League Lohas Division D</TableCell>
                        <TableCell>5A陸凱俊<br />
                            Ø</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>8</TableCell>
                        <TableCell>31/8/2024</TableCell>
                        <TableCell>香港業餘冰球會</TableCell>
                        <TableCell>2024    香港業餘冰球會冰球邀請賽金盃組</TableCell>
                        <TableCell>5A鍾傜羽</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>9</TableCell>
                        <TableCell>31/8/2024</TableCell>
                        <TableCell>香港業餘冰球會</TableCell>
                        <TableCell>2023    - 2024 香港校際冰球聯賽</TableCell>
                        <TableCell>5A鍾傜羽</TableCell>
                        <TableCell>TEAM    MVP</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>10</TableCell>
                        <TableCell>13/10/2024</TableCell>
                        <TableCell>南華體育會</TableCell>
                        <TableCell>第五十六屆香港柔道邀請錦標大賽</TableCell>
                        <TableCell>1C楊子龍</TableCell>
                        <TableCell>13至16歲組50公斤級 冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">11</TableCell>
                        <TableCell rowspan="2">2/10/2024</TableCell>
                        <TableCell rowspan="2">香港學界體育聯會 - 港島及九龍地域中學分會</TableCell>
                        <TableCell rowspan="2">中學校際游泳比賽(九龍及港島地域)</TableCell>
                        <TableCell>2A李喜兒</TableCell>
                        <TableCell>女子丙組50米蝶泳 亞軍</TableCell>
                        <TableCell rowspan="2">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1B李昕翹、1C周雨柔、2A李喜兒、2B梁家茵</TableCell>
                        <TableCell>女子丙組四式接力 殿軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>12</TableCell>
                        <TableCell>6/10/2024</TableCell>
                        <TableCell>新界青年聯會</TableCell>
                        <TableCell>新界區傑出學生選舉2024</TableCell>
                        <TableCell>4B張森蕙</TableCell>
                        <TableCell> 新界區優秀學生</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>13</TableCell>
                        <TableCell>9月</TableCell>
                        <TableCell>香港茶道總會</TableCell>
                        <TableCell>香港青少年茶文化大使校際比賽</TableCell>
                        <TableCell>3A 鄭 盈、3B    劉凱琳、4B陳姿霖、4D馬嘉怡、4B張森蕙、6A邱錦承、6B洪仟鎣<br /></TableCell>
                        <TableCell>季軍</TableCell>
                        <TableCell>內省智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>14</TableCell>
                        <TableCell>4/10/2024</TableCell>
                        <TableCell>香港教育大學</TableCell>
                        <TableCell>STEAMlympics決賽</TableCell>
                        <TableCell>4A列俊希、4A施君臨、4B張森蕙、4B溫梓健、4B翁太懋</TableCell>
                        <TableCell>優異獎</TableCell>
                        <TableCell>數理邏輯智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>15</TableCell>
                        <TableCell>3/10/2024</TableCell>
                        <TableCell>香港文藝協會</TableCell>
                        <TableCell>全港十八區    手機攝影比賽(城市)</TableCell>
                        <TableCell> 5A陳諾一</TableCell>
                        <TableCell>深水埗區 中學組 冠軍</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>16</TableCell>
                        <TableCell>15/9/2024</TableCell>
                        <TableCell>規劃署</TableCell>
                        <TableCell>慶祝中華人民共和國成立75週年 <br /></TableCell>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell>城市景觀    攝影比賽 優異獎</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">17</TableCell>
                        <TableCell rowspan="2">10月</TableCell>
                        <TableCell rowspan="2">青年兒童文藝交流協會</TableCell>
                        <TableCell rowspan="2">第九屆香港青年兒童書法比賽</TableCell>
                        <TableCell>4B 陳姿霖</TableCell>
                        <TableCell>中文 中學組 金獎</TableCell>
                        <TableCell rowspan="2">語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4A 何琪</TableCell>
                        <TableCell>中學組 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>18</TableCell>
                        <TableCell>10月</TableCell>
                        <TableCell>蓬瀛仙館</TableCell>
                        <TableCell>第三十三屆 (2024年)香港公開考試成績優良獎</TableCell>
                        <TableCell>2023-2024年度中六級畢業生吳錦樞</TableCell>
                        <TableCell>獎學金港幣五千元正及獎狀</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">19</TableCell>
                        <TableCell rowspan="2">11月 </TableCell>
                        <TableCell rowspan="2">國際兒童文化藝術發展協會</TableCell>
                        <TableCell rowspan="2">2024「國際兒童及青少年徵文大賽」</TableCell>
                        <TableCell>4A何琪</TableCell>
                        <TableCell>高中組 中文組 金獎</TableCell>
                        <TableCell rowspan="2">語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4B陳姿霖</TableCell>
                        <TableCell>高中組 中文組 銀獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">20</TableCell>
                        <TableCell rowspan="2">11月 </TableCell>
                        <TableCell rowspan="2">兒童藝術文化協會</TableCell>
                        <TableCell rowspan="2">「第九屆全港兒童書法比賽2024」</TableCell>
                        <TableCell> 4A何琪</TableCell>
                        <TableCell> 中文硬筆書法 中學組 冠軍</TableCell>
                        <TableCell rowspan="2">語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4B陳姿霖</TableCell>
                        <TableCell>中文硬筆書法 中學組 亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>21</TableCell>
                        <TableCell> 27/10/2024</TableCell>
                        <TableCell>香港業餘冰球會</TableCell>
                        <TableCell>Hong    Kong Ice Hockey Fun League</TableCell>
                        <TableCell> 5A鍾傜羽</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>22</TableCell>
                        <TableCell>17/11/2024</TableCell>
                        <TableCell>中國香港柔道總會</TableCell>
                        <TableCell>2024年度香港校際柔道錦標賽 </TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>男童B組 46公斤 冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>23</TableCell>
                        <TableCell>10/11/2024</TableCell>
                        <TableCell>北區體育會</TableCell>
                        <TableCell>第三屆北區柔道錦標賽 </TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>男童丁組 45公斤 亞軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>24</TableCell>
                        <TableCell>3/11/2024</TableCell>
                        <TableCell>中國香港柔道總會</TableCell>
                        <TableCell>2024年度香港青少年柔道錦標賽</TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>男童C組 46公斤 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>25</TableCell>
                        <TableCell>11/10/2024</TableCell>
                        <TableCell>香港實用跆拳道協會</TableCell>
                        <TableCell>實用盃跆拳道錦標賽2024</TableCell>
                        <TableCell> 2B賴一霖</TableCell>
                        <TableCell> 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>26</TableCell>
                        <TableCell>12/10/2024</TableCell>
                        <TableCell>樂武跆拳道會</TableCell>
                        <TableCell>樂武跆拳道錦標賽2024</TableCell>
                        <TableCell> 2B黃竟堯</TableCell>
                        <TableCell>季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>27</TableCell>
                        <TableCell> 20/10/2024</TableCell>
                        <TableCell>心回球場</TableCell>
                        <TableCell>三人籃球賽 2024 U15 決賽</TableCell>
                        <TableCell>3A蔡煒煌、4B梁君安、4B馬梓唐、4B冼曉煬、4D梅正然</TableCell>
                        <TableCell> 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">28</TableCell>
                        <TableCell rowspan="3">19/11/2024</TableCell>
                        <TableCell rowspan="3">香港學界體育聯會    港島及九龍地域中學分會 </TableCell>
                        <TableCell rowspan="3">中學校際田徑比賽(九龍及港島地域D3A3)</TableCell>
                        <TableCell>5A吳朗埄</TableCell>
                        <TableCell>男子甲組鐵餅 亞軍</TableCell>
                        <TableCell rowspan="3">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6B周以傑</TableCell>
                        <TableCell>男子甲組標槍 殿軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6E黃啟晉</TableCell>
                        <TableCell>男子甲組5000米 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>29</TableCell>
                        <TableCell>13/10/2024</TableCell>
                        <TableCell>南華體育會 </TableCell>
                        <TableCell>第五十六屆香港柔道邀請錦標大賽</TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>13至16歲組45公斤級 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>30</TableCell>
                        <TableCell>10月</TableCell>
                        <TableCell>香港文創薈</TableCell>
                        <TableCell>八月十五中秋節繪畫比賽</TableCell>
                        <TableCell> 5A 李靖昤</TableCell>
                        <TableCell> 青少年組 冠軍</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>31</TableCell>
                        <TableCell>20/12/2024</TableCell>
                        <TableCell>中銀香港</TableCell>
                        <TableCell>第三屆「我與香港的小故事」主題攝影比賽 </TableCell>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell>中學組 專業組 冠軍</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>32</TableCell>
                        <TableCell>7月</TableCell>
                        <TableCell>Good    Morning Class</TableCell>
                        <TableCell>第六屆J3 - J18全港青幼童大賞繪畫比賽x神戶展</TableCell>
                        <TableCell> 4B 鄒月彤</TableCell>
                        <TableCell>J13-J15西洋畫組 銀獎</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>33</TableCell>
                        <TableCell>10月</TableCell>
                        <TableCell>葛羅夫文化藝術中心</TableCell>
                        <TableCell>卡通手繪動漫角色繪畫競賽(手繪/電繪)</TableCell>
                        <TableCell> 5A 戴  晴</TableCell>
                        <TableCell> 銀獎</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>34</TableCell>
                        <TableCell>24/12/2024</TableCell>
                        <TableCell>中華人民共和國香港特別行政區政府教育局 </TableCell>
                        <TableCell>初中歷史科電子閱讀獎勵計劃 2024</TableCell>
                        <TableCell>2A馮靖喬、2A李子芊、2A孫愿慈、2B梁家茵<br />
                            3A林靄千、3A施韻茵、3A陳煒軒</TableCell>
                        <TableCell>嘉許獎 及「學校參與獎」</TableCell>
                        <TableCell>語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">35</TableCell>
                        <TableCell rowspan="3">12月</TableCell>
                        <TableCell rowspan="3">義務工作發展局</TableCell>
                        <TableCell rowspan="3">香港義工獎2024</TableCell>
                        <TableCell>本校榮獲「賽馬會眾心行善愛心學校」奬項</TableCell>
                        <TableCell>　</TableCell>
                        <TableCell rowspan="3">人際關係</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2B 陳莉欣、3B 劉凱琳、4A    列俊希、4A 張鐫騫<br />
                            4A 黃以穎、4B 張森蕙、4C 張喜朗、5A 孫暉喬<br />
                            5A 許晴晴、6A 甘合宗、6A 李子苗、6A 邱錦承<br />
                            6A 黃思朗、6A 黃悅頤、6A 趙偉昌、6A 潘嘉善<br />
                            6A 賴曉俊、6E 林子樂</TableCell>
                        <TableCell>銀獎 (義工時數100    - 299小時)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3A 古豐源、3A 梁峻康、3A    陳舒萍、3A楊明玥<br />
                            3A 楊政淳、3A 葉子樂、3A    蔡煒煌、3A 鄭     盈<br />
                            3B 李國英、3B 林廷軒、3B    張芯悅、3B 鍾葦彤<br />
                            3B 關志聰、3C 郭芷蕁、3C    郭雅雯、3D周凱晴<br />
                            4A 成丹妮、4A 江宜庭、4A    林子迅、4A 梁俊胤<br />
                            4A 劉子瑜、4A 劉梓孝、4A    薛栢希、4B 白家俊<br />
                            4B 李家佑、4B 冼曉煬、4B    周靈兒、4B 馬嘉怡<br />
                            4B 陳姿霖、4B 劉潔瑩、4C    陳佩雯、4C楊穎翹<br />
                            4D 李煜珩、4D 林芷彤、5A    吳依凌、5A吳詩韻<br />
                            5A 李靖昤、5A 李穎琳、5A    陳榮錄、5A黃國鋒<br />
                            5A 溫凱翔、5A 鍾傜羽、5A    顏浩然、5B文卓楠<br />
                            5B 王慧琳、5B 石俊生、5B    吳汶錡、5B 鄧凱琳<br />
                            5B 譚凱鍵、5C 劉澤霖、5D    陳鎧澄、5E李婥僑<br />
                            6A 馬梓曦、6A 張凱鎣、6A    陳柏同、6A 曾冠瀤<br />
                            6A 盧曉威、6A 羅泳詩、6B    Aldorino Syawiyanli<br />
                            6B 何迦南、6B 吳詠兒、6B 吳嘉豪、6B 李仲彥<br />
                            6B 李詩晴、6B 阮穎翹、6B    周以傑、6B 周嘉晞<br />
                            6B 陳柏妍、6B 龔子蔚、6C    余東澤、6D 文寶婷<br />
                            6D 王瑞瑩、6D 何愷林、6D    吳凱嵐、6D 高友緣<br />
                            6D 曾雪瀅、6E 范熙俊、6E    陳皋鳳</TableCell>
                        <TableCell>銅獎 (義工時數50 - 99小時)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>36</TableCell>
                        <TableCell>1月</TableCell>
                        <TableCell>香港青年交流促進聯會</TableCell>
                        <TableCell>「愛心行動獎」</TableCell>
                        <TableCell> 6A 李子苗、5A    李穎琳、5A 傅家儀、5A 許晴晴</TableCell>
                        <TableCell>嘉許證書</TableCell>
                        <TableCell>人際關係</TableCell>
                    </TableRow>
                </Table>
            </TableContainer>
        </Paper>
    );

    const Table2025 = () => (
        <Paper sx={{ mt: 2 }}>
            <TableContainer>
                <Table cellspacing="0" cellpadding="0">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>　</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>舉行日期</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>主辦機構</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>比賽項目</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>學生姓名</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>名次</TableCell>
                            <TableCell align="center" sx={{ backgroundColor: 'primary.main', color: 'white' }}>智能範疇</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableRow>
                        <TableCell rowspan="2">1</TableCell>
                        <TableCell rowspan="2">8月/2024</TableCell>
                        <TableCell rowspan="2">西貢文化中心<br />
                            社區發展基金會<br />
                            有限公司、西貢區校長會、友凝</TableCell>
                        <TableCell rowspan="2">第二十三屆西貢區傑出學生選舉</TableCell>
                        <TableCell>1A 陳嘉齊</TableCell>
                        <TableCell> 十大傑出學生優勝盃 </TableCell>
                        <TableCell rowspan="2">多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3B張森蕙、5A陳榮錄、5A孫暉喬</TableCell>
                        <TableCell>傑出學生嘉許狀 </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">2</TableCell>
                        <TableCell rowspan="2">8月/2024</TableCell>
                        <TableCell rowspan="2">香港旅遊事務署及香港青年協會</TableCell>
                        <TableCell rowspan="2">香港青年大使計劃</TableCell>
                        <TableCell>6A 黃悅頤、6E    林子樂</TableCell>
                        <TableCell>金章</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6A 李子苗</TableCell>
                        <TableCell>銀章、傑出計劃年獎</TableCell>
                        <TableCell rowspan="2">邏輯數學智能、空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3</TableCell>
                        <TableCell>3/8/2024</TableCell>
                        <TableCell>香港高等教育科技學院(THEi)</TableCell>
                        <TableCell rowspan="2">THEi    BIM比賽2024：將數碼建築及設備工程帶入校園</TableCell>
                        <TableCell> 4B馬梓唐、4B周靈兒、4C黎嘉善</TableCell>
                        <TableCell>二等獎 Bronze Award</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4</TableCell>
                        <TableCell>9月</TableCell>
                        <TableCell>中國民政部</TableCell>
                        <TableCell>2B    陳莉欣、3A 鄭盈、3B 鍾葦彤、4B 陳姿霖</TableCell>
                        <TableCell>全國青少年茶藝師證書</TableCell>
                        <TableCell>內省智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5</TableCell>
                        <TableCell>6/7/2024</TableCell>
                        <TableCell>青年學院</TableCell>
                        <TableCell>校際室內拉機邀請賽 2024</TableCell>
                        <TableCell>3B林廷軒</TableCell>
                        <TableCell>男子初中組 300米第8名</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">6</TableCell>
                        <TableCell rowspan="3">21/7/2024</TableCell>
                        <TableCell rowspan="3">沙田體育會</TableCell>
                        <TableCell rowspan="3">新界區室內三項鐵人賽    2024</TableCell>
                        <TableCell>3C陳荔瑩</TableCell>
                        <TableCell>女子個人全港中學生組殿軍</TableCell>
                        <TableCell rowspan="3">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5E李婥僑</TableCell>
                        <TableCell>女子個人全港中學生組第5名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3C陳荔瑩、5E李婥僑</TableCell>
                        <TableCell>隊際全港中學生女子組殿軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>7</TableCell>
                        <TableCell>31/8/2024</TableCell>
                        <TableCell>Hong    Kong Academy of Ice Hockey</TableCell>
                        <TableCell>2024    Summer Amateur Hockey League Lohas Division D</TableCell>
                        <TableCell>5A陸凱俊<br />
                            Ø</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>8</TableCell>
                        <TableCell>31/8/2024</TableCell>
                        <TableCell>香港業餘冰球會</TableCell>
                        <TableCell>2024    香港業餘冰球會冰球邀請賽金盃組</TableCell>
                        <TableCell>5A鍾傜羽</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>9</TableCell>
                        <TableCell>31/8/2024</TableCell>
                        <TableCell>香港業餘冰球會</TableCell>
                        <TableCell>2023    - 2024 香港校際冰球聯賽</TableCell>
                        <TableCell>5A鍾傜羽</TableCell>
                        <TableCell>TEAM    MVP</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>10</TableCell>
                        <TableCell>13/10/2024</TableCell>
                        <TableCell>南華體育會</TableCell>
                        <TableCell>第五十六屆香港柔道邀請錦標大賽</TableCell>
                        <TableCell>1C楊子龍</TableCell>
                        <TableCell>13至16歲組50公斤級 冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">11</TableCell>
                        <TableCell rowspan="2">2/10/2024</TableCell>
                        <TableCell rowspan="2">香港學界體育聯會 - 港島及九龍地域中學分會</TableCell>
                        <TableCell rowspan="2">中學校際游泳比賽(九龍及港島地域)</TableCell>
                        <TableCell>2A李喜兒</TableCell>
                        <TableCell>女子丙組50米蝶泳 亞軍</TableCell>
                        <TableCell rowspan="2">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1B李昕翹、1C周雨柔、2A李喜兒、2B梁家茵</TableCell>
                        <TableCell>女子丙組四式接力 殿軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>12</TableCell>
                        <TableCell>6/10/2024</TableCell>
                        <TableCell>新界青年聯會</TableCell>
                        <TableCell>新界區傑出學生選舉2024</TableCell>
                        <TableCell>4B張森蕙</TableCell>
                        <TableCell> 新界區優秀學生</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>13</TableCell>
                        <TableCell>9月</TableCell>
                        <TableCell>香港茶道總會</TableCell>
                        <TableCell>香港青少年茶文化大使校際比賽</TableCell>
                        <TableCell>3A 鄭 盈、3B    劉凱琳、4B陳姿霖、4D馬嘉怡、4B張森蕙、6A邱錦承、6B洪仟鎣<br /></TableCell>
                        <TableCell>季軍</TableCell>
                        <TableCell>內省智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>14</TableCell>
                        <TableCell>4/10/2024</TableCell>
                        <TableCell>香港教育大學</TableCell>
                        <TableCell>STEAMlympics決賽</TableCell>
                        <TableCell>4A列俊希、4A施君臨、4B張森蕙、4B溫梓健、4B翁太懋</TableCell>
                        <TableCell>優異獎</TableCell>
                        <TableCell>數理邏輯智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>15</TableCell>
                        <TableCell>3/10/2024</TableCell>
                        <TableCell>香港文藝協會</TableCell>
                        <TableCell>全港十八區    手機攝影比賽(城市)</TableCell>
                        <TableCell> 5A陳諾一</TableCell>
                        <TableCell>深水埗區 中學組 冠軍</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>16</TableCell>
                        <TableCell>15/9/2024</TableCell>
                        <TableCell>規劃署</TableCell>
                        <TableCell>慶祝中華人民共和國成立75週年 <br /></TableCell>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell>城市景觀    攝影比賽 優異獎</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">17</TableCell>
                        <TableCell rowspan="2">10月</TableCell>
                        <TableCell rowspan="2">青年兒童文藝交流協會</TableCell>
                        <TableCell rowspan="2">第九屆香港青年兒童書法比賽</TableCell>
                        <TableCell>4B 陳姿霖</TableCell>
                        <TableCell>中文 中學組 金獎</TableCell>
                        <TableCell rowspan="2">語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4A 何琪</TableCell>
                        <TableCell>中學組 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>18</TableCell>
                        <TableCell>10月</TableCell>
                        <TableCell>蓬瀛仙館</TableCell>
                        <TableCell>第三十三屆 (2024年)香港公開考試成績優良獎</TableCell>
                        <TableCell>2023-2024年度中六級畢業生吳錦樞</TableCell>
                        <TableCell>獎學金港幣五千元正及獎狀</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">19</TableCell>
                        <TableCell rowspan="2">11月 </TableCell>
                        <TableCell rowspan="2">國際兒童文化藝術發展協會</TableCell>
                        <TableCell rowspan="2">2024「國際兒童及青少年徵文大賽」</TableCell>
                        <TableCell>4A何琪</TableCell>
                        <TableCell>高中組 中文組 金獎</TableCell>
                        <TableCell rowspan="2">語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4B陳姿霖</TableCell>
                        <TableCell>高中組 中文組 銀獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">20</TableCell>
                        <TableCell rowspan="2">11月 </TableCell>
                        <TableCell rowspan="2">兒童藝術文化協會</TableCell>
                        <TableCell rowspan="2">「第九屆全港兒童書法比賽2024」</TableCell>
                        <TableCell> 4A何琪</TableCell>
                        <TableCell> 中文硬筆書法 中學組 冠軍</TableCell>
                        <TableCell rowspan="2">語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4B陳姿霖</TableCell>
                        <TableCell>中文硬筆書法 中學組 亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>21</TableCell>
                        <TableCell> 27/10/2024</TableCell>
                        <TableCell>香港業餘冰球會</TableCell>
                        <TableCell>Hong    Kong Ice Hockey Fun League</TableCell>
                        <TableCell> 5A鍾傜羽</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>22</TableCell>
                        <TableCell>17/11/2024</TableCell>
                        <TableCell>中國香港柔道總會</TableCell>
                        <TableCell>2024年度香港校際柔道錦標賽 </TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>男童B組 46公斤 冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>23</TableCell>
                        <TableCell>10/11/2024</TableCell>
                        <TableCell>北區體育會</TableCell>
                        <TableCell>第三屆北區柔道錦標賽 </TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>男童丁組 45公斤 亞軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>24</TableCell>
                        <TableCell>3/11/2024</TableCell>
                        <TableCell>中國香港柔道總會</TableCell>
                        <TableCell>2024年度香港青少年柔道錦標賽</TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>男童C組 46公斤 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>25</TableCell>
                        <TableCell>11/10/2024</TableCell>
                        <TableCell>香港實用跆拳道協會</TableCell>
                        <TableCell>實用盃跆拳道錦標賽2024</TableCell>
                        <TableCell> 2B賴一霖</TableCell>
                        <TableCell> 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>26</TableCell>
                        <TableCell>12/10/2024</TableCell>
                        <TableCell>樂武跆拳道會</TableCell>
                        <TableCell>樂武跆拳道錦標賽2024</TableCell>
                        <TableCell> 2B黃竟堯</TableCell>
                        <TableCell>季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>27</TableCell>
                        <TableCell> 20/10/2024</TableCell>
                        <TableCell>心回球場</TableCell>
                        <TableCell>三人籃球賽 2024 U15    決賽</TableCell>
                        <TableCell>3A蔡煒煌、4B梁君安、4B馬梓唐、4B冼曉煬、4D梅正然</TableCell>
                        <TableCell> 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">28</TableCell>
                        <TableCell rowspan="3">19/11/2024</TableCell>
                        <TableCell rowspan="3">香港學界體育聯會    港島及九龍地域中學分會 </TableCell>
                        <TableCell rowspan="3">中學校際田徑比賽(九龍及港島地域D3A3)</TableCell>
                        <TableCell>5A吳朗埄</TableCell>
                        <TableCell>男子甲組鐵餅 亞軍</TableCell>
                        <TableCell rowspan="3">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6B周以傑</TableCell>
                        <TableCell>男子甲組標槍 殿軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6E黃啟晉</TableCell>
                        <TableCell>男子甲組5000米 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>29</TableCell>
                        <TableCell>13/10/2024</TableCell>
                        <TableCell>南華體育會 </TableCell>
                        <TableCell>第五十六屆香港柔道邀請錦標大賽</TableCell>
                        <TableCell>1D廖卓翹</TableCell>
                        <TableCell>13至16歲組45公斤級 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>30</TableCell>
                        <TableCell>10月</TableCell>
                        <TableCell>香港文創薈</TableCell>
                        <TableCell>八月十五中秋節繪畫比賽</TableCell>
                        <TableCell> 5A 李靖昤</TableCell>
                        <TableCell> 青少年組 冠軍</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>31</TableCell>
                        <TableCell>20/12/2024</TableCell>
                        <TableCell>中銀香港</TableCell>
                        <TableCell>第三屆「我與香港的小故事」主題攝影比賽 </TableCell>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell>中學組 專業組 冠軍</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>32</TableCell>
                        <TableCell>7月</TableCell>
                        <TableCell>Good    Morning Class</TableCell>
                        <TableCell>第六屆J3 - J18全港青幼童大賞繪畫比賽x神戶展</TableCell>
                        <TableCell> 4B 鄒月彤</TableCell>
                        <TableCell>J13-J15西洋畫組 銀獎</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>33</TableCell>
                        <TableCell>10月</TableCell>
                        <TableCell>葛羅夫文化藝術中心</TableCell>
                        <TableCell>卡通手繪動漫角色繪畫競賽(手繪/電繪)</TableCell>
                        <TableCell> 5A 戴  晴</TableCell>
                        <TableCell> 銀獎</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>34</TableCell>
                        <TableCell>24/12/2024</TableCell>
                        <TableCell>中華人民共和國香港特別行政區政府教育局 </TableCell>
                        <TableCell>初中歷史科電子閱讀獎勵計劃 2024</TableCell>
                        <TableCell>2A馮靖喬、2A李子芊、2A孫愿慈、2B梁家茵<br />
                            3A林靄千、3A施韻茵、3A陳煒軒</TableCell>
                        <TableCell>嘉許獎 及「學校參與獎」</TableCell>
                        <TableCell>語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">35</TableCell>
                        <TableCell rowspan="3">12月</TableCell>
                        <TableCell rowspan="3">義務工作發展局</TableCell>
                        <TableCell rowspan="3">香港義工獎2024</TableCell>
                        <TableCell>本校榮獲「賽馬會眾心行善愛心學校」奬項</TableCell>
                        <TableCell>　</TableCell>
                        <TableCell rowspan="3">人際關係</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2B 陳莉欣、3B 劉凱琳、4A    列俊希、4A 張鐫騫<br />
                            4A 黃以穎、4B 張森蕙、4C 張喜朗、5A 孫暉喬<br />
                            5A 許晴晴、6A 甘合宗、6A 李子苗、6A 邱錦承<br />
                            6A 黃思朗、6A 黃悅頤、6A 趙偉昌、6A 潘嘉善<br />
                            6A 賴曉俊、6E 林子樂</TableCell>
                        <TableCell>銀獎 (義工時數100    - 299小時)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3A 古豐源、3A 梁峻康、3A    陳舒萍、3A楊明玥<br />
                            3A 楊政淳、3A 葉子樂、3A    蔡煒煌、3A 鄭     盈<br />
                            3B 李國英、3B 林廷軒、3B    張芯悅、3B 鍾葦彤<br />
                            3B 關志聰、3C 郭芷蕁、3C    郭雅雯、3D周凱晴<br />
                            4A 成丹妮、4A 江宜庭、4A    林子迅、4A 梁俊胤<br />
                            4A 劉子瑜、4A 劉梓孝、4A    薛栢希、4B 白家俊<br />
                            4B 李家佑、4B 冼曉煬、4B    周靈兒、4B 馬嘉怡<br />
                            4B 陳姿霖、4B 劉潔瑩、4C    陳佩雯、4C楊穎翹<br />
                            4D 李煜珩、4D 林芷彤、5A    吳依凌、5A吳詩韻<br />
                            5A 李靖昤、5A 李穎琳、5A    陳榮錄、5A黃國鋒<br />
                            5A 溫凱翔、5A 鍾傜羽、5A    顏浩然、5B文卓楠<br />
                            5B 王慧琳、5B 石俊生、5B    吳汶錡、5B 鄧凱琳<br />
                            5B 譚凱鍵、5C 劉澤霖、5D    陳鎧澄、5E李婥僑<br />
                            6A 馬梓曦、6A 張凱鎣、6A    陳柏同、6A 曾冠瀤<br />
                            6A 盧曉威、6A 羅泳詩、6B    Aldorino Syawiyanli<br />
                            6B 何迦南、6B 吳詠兒、6B 吳嘉豪、6B 李仲彥<br />
                            6B 李詩晴、6B 阮穎翹、6B    周以傑、6B 周嘉晞<br />
                            6B 陳柏妍、6B 龔子蔚、6C    余東澤、6D 文寶婷<br />
                            6D 王瑞瑩、6D 何愷林、6D    吳凱嵐、6D 高友緣<br />
                            6D 曾雪瀅、6E 范熙俊、6E    陳皋鳳</TableCell>
                        <TableCell>銅獎 (義工時數50 - 99小時)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>36</TableCell>
                        <TableCell>30/11/2024</TableCell>
                        <TableCell>通訊事務管理局辦公室 </TableCell>
                        <TableCell>「5G校園應用創作比賽2024」決賽</TableCell>
                        <TableCell>6A甘合宗、6A江卓恆、6A曾冠瀤、6E陳進宇、6E李晃希</TableCell>
                        <TableCell>季軍</TableCell>
                        <TableCell>邏輯數理智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>37</TableCell>
                        <TableCell>1月</TableCell>
                        <TableCell>香港青年交流促進聯會</TableCell>
                        <TableCell>「愛心行動獎」</TableCell>
                        <TableCell> 6A 李子苗、5A    李穎琳、5A 傅家儀、5A 許晴晴</TableCell>
                        <TableCell>嘉許證書</TableCell>
                        <TableCell>人際關係</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>38</TableCell>
                        <TableCell>20/2/2025</TableCell>
                        <TableCell>香港專業教育<br />
                            學院及鵬程慈善基金</TableCell>
                        <TableCell>鵬程慈善基金 - STEM in PE設計比賽</TableCell>
                        <TableCell>1A廖子敬、2A陳嘉齊、4B溫梓健、4B翁太懋</TableCell>
                        <TableCell>我最喜愛設計大獎(中學組) 冠軍</TableCell>
                        <TableCell>邏輯數理智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>39</TableCell>
                        <TableCell>11月</TableCell>
                        <TableCell>國際青少年文藝培訓中心</TableCell>
                        <TableCell>第十七屆國際公開繪畫大賽 </TableCell>
                        <TableCell>4B蔡泓浚</TableCell>
                        <TableCell> 16歲組 我愛大自然 亞軍</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>40</TableCell>
                        <TableCell>11月</TableCell>
                        <TableCell>香港青年協會</TableCell>
                        <TableCell>2024徐悲鴻盃國際青少年兒童美術比賽(香港賽區)</TableCell>
                        <TableCell>4B    蔡泓浚</TableCell>
                        <TableCell>西洋畫系 中學組 一等獎<br />
                            中國畫系 中學組 優異獎</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="5">41</TableCell>
                        <TableCell rowspan="5">23/2/2025</TableCell>
                        <TableCell rowspan="5">中國香港匹克球總會</TableCell>
                        <TableCell rowspan="5">香港匹克球青少年公開賽2024</TableCell>
                        <TableCell>2A方沛琳</TableCell>
                        <TableCell>U15女子單打 冠軍</TableCell>
                        <TableCell rowspan="5">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A 陳嘉齊</TableCell>
                        <TableCell>U15女子單打 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A 鄧家昊</TableCell>
                        <TableCell>U15男子單打 亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A 鄧家昊 、2C何靖喆</TableCell>
                        <TableCell>U15男子雙打 亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A 方沛琳、2A 陳嘉齊</TableCell>
                        <TableCell>U15及U18女子雙打 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>42</TableCell>
                        <TableCell>15/12/2024</TableCell>
                        <TableCell>西貢區體育會</TableCell>
                        <TableCell>西貢區公開長跑比賽</TableCell>
                        <TableCell>5A陳諾一、5B黃允璞、5B吳卓恒、5B石俊生</TableCell>
                        <TableCell>5公里中學團體賽(男子組) 季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">43</TableCell>
                        <TableCell rowspan="3">19/1/2025</TableCell>
                        <TableCell rowspan="3">博愛醫院</TableCell>
                        <TableCell rowspan="3">博愛老夫子香港慈善跑</TableCell>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell>3公里個人賽 男子少年組 冠軍</TableCell>
                        <TableCell rowspan="3">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5B黃允璞</TableCell>
                        <TableCell>3公里個人賽 男子少年組 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6E黃啟晉</TableCell>
                        <TableCell>10公里個人賽 男子少年組 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="6">44</TableCell>
                        <TableCell rowspan="6">18/2/2025</TableCell>
                        <TableCell rowspan="6">香港學界體育聯會 - 港島及九龍地域中學分會</TableCell>
                        <TableCell rowspan="6">校際越野錦標賽—第三組(二區)</TableCell>
                        <TableCell>5A陳諾一、5B吳卓恒、5B石俊生、5B黃允璞<br />
                            5B孔俊傑、5E黃瑋樂、6C梁鎮朗、6E黃啟晉</TableCell>
                        <TableCell>男子甲組團體 冠軍</TableCell>
                        <TableCell rowspan="8">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1A盧昱霈、1B鄧安迪、1C李韋霖、1D李京岸<br />
                            2A陳諾恆、2B賴一霖、2C吳文博、3A葉子樂<br />
                            3B林廷軒、3B黃允臻、4B馬梓唐、4B翁太懋<br />
                            4C林暉程、4C林子敬、4D馬崇倫、5A陳諾一<br />
                            5B吳卓恒、5B石俊生、5B黃允璞、5B孔俊傑<br />
                            5E黃瑋樂、6C梁鎮朗、6E黃啟晉</TableCell>
                        <TableCell>男子總團體 殿軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A方沛琳</TableCell>
                        <TableCell>女子丙組 第8名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell>男子甲組 第7名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5B石俊生</TableCell>
                        <TableCell>男子甲組 第8名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>6E黃啟晉</TableCell>
                        <TableCell>男子甲組 第6名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">45</TableCell>
                        <TableCell rowspan="2">26/1/2025</TableCell>
                        <TableCell rowspan="2">香港遊艇會</TableCell>
                        <TableCell rowspan="2"> 2025    Youth Rowing Series - Ergo 划艇比賽 </TableCell>
                        <TableCell>3B林廷軒</TableCell>
                        <TableCell>男子12-14歲個人500米 冠軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3A葉子樂</TableCell>
                        <TableCell>男子12-14歲個人500米 亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>46</TableCell>
                        <TableCell>24/1/2025</TableCell>
                        <TableCell>尤德爵士紀念基金理事會</TableCell>
                        <TableCell>2024/25年度尤德爵士紀念基金獎學金</TableCell>
                        <TableCell>6A張凱鎣、6A郭浚傑</TableCell>
                        <TableCell> 獎學金一千元正及獎狀</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>47</TableCell>
                        <TableCell>12月</TableCell>
                        <TableCell>香港國際文藝<br />
                            交流協會</TableCell>
                        <TableCell>全方位比賽平台 - 2024專題繪畫/攝影比賽 歡度聖誕</TableCell>
                        <TableCell>4B 蔡泓浚</TableCell>
                        <TableCell>青年組 繪畫 冠軍</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>48</TableCell>
                        <TableCell>1/2/2025</TableCell>
                        <TableCell>香港國際鋼琴節<br />
                            香港演藝協進會</TableCell>
                        <TableCell>香港國際鋼琴節2025<br /></TableCell>
                        <TableCell>5A    顏浩然</TableCell>
                        <TableCell>流行鋼琴組(中學組) 冠軍</TableCell>
                        <TableCell>音樂智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>49</TableCell>
                        <TableCell>1/11/2024</TableCell>
                        <TableCell>香港青年兒童文藝協會</TableCell>
                        <TableCell>第二屆激樂流行鼓大賽2024</TableCell>
                        <TableCell>1B陳子曦</TableCell>
                        <TableCell>兒童高級組 銀獎</TableCell>
                        <TableCell>音樂智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="8">50</TableCell>
                        <TableCell rowspan="8">20/3/2025</TableCell>
                        <TableCell rowspan="8">香港聯校音樂協會</TableCell>
                        <TableCell rowspan="8">聯校音樂大賽2025</TableCell>
                        <TableCell> 1A楊家蕙、1A鄔震霆、1B張嘉恩、1B梁芷寧<br />
                            1B梁詠淘、1B林嘉言、1B吳紫晴、1B譚凱盈<br />
                            1B王芷霖、1B陳浚僑、1C梁詠堤、1C郭烜睿<br />
                            1C許善博、1D曹鈺雯、1D李紫晴、1D樊祉皓<br />
                            2A霍梓柔、2A馮靖喬、2B黃焯榆、3A張卓琳<br />
                            3A施韻茵、3B鄧美蓮、3D盧以諾、4A徐若藍<br />
                            4A蔡梓涵、4A薛栢希、4A薛栢朗、4A邱羿潼<br />
                            4B李家佑、4C黎嘉善、4C吳凱晴、5A黃國鋒<br />
                            5B潘卓瑤、5C王嘉怡</TableCell>
                        <TableCell>管樂團(中學組) 銀獎</TableCell>
                        <TableCell rowspan="8">音樂智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5A顏浩然</TableCell>
                        <TableCell>中學(鋼琴)獨奏 - 高級組 金獎<br />
                            中學(歌唱組)獨唱 - 流行曲    銅獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3B李國英、3D黃珮瑩、4C鍾煦柔、5B鄧凱琳、6C梁鎮朗</TableCell>
                        <TableCell>中學(歌唱組)獨唱 - 流行曲 銀獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1B鄧宇希、2A鄭采寶、2A顧紫睿、5B潘卓瑤、6E林子樂</TableCell>
                        <TableCell> 中學(歌唱組)獨唱 - 流行曲 銅獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4C陳子謙</TableCell>
                        <TableCell>中學體驗組(獨奏) 金獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4A何     琪</TableCell>
                        <TableCell>中學(歌唱組)獨唱 - 流行曲 金獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1A何傲弦、4D馬嘉怡、5A溫凱翔</TableCell>
                        <TableCell>中學(鋼琴)獨奏 - 高級組 銀獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5E李婥僑</TableCell>
                        <TableCell>中學弦樂(結他)獨奏 - 中級組 銀獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">51</TableCell>
                        <TableCell rowspan="2">Mar-25</TableCell>
                        <TableCell rowspan="2">博愛醫院教育服務部</TableCell>
                        <TableCell rowspan="2">2024至2025年度博愛醫院傑出學生選舉(陳首銘博士獎學金)</TableCell>
                        <TableCell> 5A顏浩然</TableCell>
                        <TableCell>銀獎 </TableCell>
                        <TableCell rowspan="2">多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 5A陳榮錄 </TableCell>
                        <TableCell>銅獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="4">52</TableCell>
                        <TableCell rowspan="4">22/3/2025</TableCell>
                        <TableCell rowspan="4">中華倫敦協會</TableCell>
                        <TableCell rowspan="4">中華倫敦協會	MY DREAM 先導計劃</TableCell>
                        <TableCell>3A 戴璧瞳</TableCell>
                        <TableCell>冠軍並獲獎學金港幣$2000</TableCell>
                        <TableCell rowspan="4">多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3A 施韻茵</TableCell>
                        <TableCell>亞軍並獲獎學金港幣$1000</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A 楊雯曦</TableCell>
                        <TableCell>季軍並獲獎學金港幣$600</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1A陳詩盈、1B梁詠淘、2A譚凱瑤、3A林靄千<br />
                            3A羅泯沂、3A謝林峰、3B張芯悅</TableCell>
                        <TableCell>優異獎並各獲獎學金港幣$200</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="4">53</TableCell>
                        <TableCell rowspan="4">13/3/2025</TableCell>
                        <TableCell rowspan="4">香港青少年及兒童才藝表演協會</TableCell>
                        <TableCell rowspan="4">香港青少年及兒童才藝表演協會	第三屆香港青少年及兒童攝影大賽</TableCell>
                        <TableCell>1D蔡衍樂</TableCell>
                        <TableCell>自由主題組(中學S.1-S.3組)    冠軍<br />
                            最佳攝影作品大獎</TableCell>
                        <TableCell rowspan="4">空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A馮靖喬</TableCell>
                        <TableCell>自然攝影組及自由主題組(中學S.1-S.3組) 季軍<br />
                            最具潛質大獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A張芷澄</TableCell>
                        <TableCell>自然攝影組(中學S.1-S.3組)    亞軍<br />
                            最佳創意構圖大獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5A 陳諾一</TableCell>
                        <TableCell>街頭攝影組(中學S.4-S.6組)    冠軍<br />
                            最佳攝影作品大獎 及 最佳創意構圖大獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>54</TableCell>
                        <TableCell>26/4/2025</TableCell>
                        <TableCell>裕華國產百貨有限公司/中苑攝影學會有限公司</TableCell>
                        <TableCell>拍出香港「攝」人魅力 - 香港風光 香港中學生攝影比賽</TableCell>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell><br />
                            優異獎</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>55</TableCell>
                        <TableCell>7/12/2024</TableCell>
                        <TableCell>香港青年協會</TableCell>
                        <TableCell>西貢區五人足球邀請賽 2024 </TableCell>
                        <TableCell>3A劉澤賢、4A何智富、4B蔡泓浚、4B顏浩天<br />
                            4B謝家俊、4C林煒東、4C陸梓峰、4D劉善恒<br />
                            5C劉澤霖、5D譚臻廷</TableCell>
                        <TableCell>亞軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>56</TableCell>
                        <TableCell>21/12/2024</TableCell>
                        <TableCell>香港學界體育聯會 - 港島及九龍地域中學分會</TableCell>
                        <TableCell>中學校際排球錦標賽(D3九龍地域)</TableCell>
                        <TableCell> 4A梁俊胤、4C莫盈臻、5B陳煥榮、5B孔俊傑<br />
                            5B蕭俊熙、5B譚凱鍵、5C丁郗彥、5E林煜坤<br />
                            5E葉華駿、6C梁鎮朗</TableCell>
                        <TableCell>季軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">57</TableCell>
                        <TableCell rowspan="3">1/10/2024</TableCell>
                        <TableCell rowspan="3">香港聯校音樂協會</TableCell>
                        <TableCell rowspan="3"><a href="mailto:Music@e-Contest%20國際網上音樂比賽">Music@e-Contest    國際網上音樂比賽</a></TableCell>
                        <TableCell>管樂團比賽：<br />
                            1A楊家蕙、1A鄔震霆、1B張嘉恩、1B梁芷寧<br />
                            1B梁詠淘、1B林嘉言、1B吳紫晴、1B譚凱盈<br />
                            1B王芷霖、1B陳浚僑、1C梁詠堤、1C郭烜睿<br />
                            1C許善博、1D曹鈺雯、1D李紫晴、1D樊祉皓<br />
                            2A霍梓柔、2A馮靖喬、2B黃焯榆、3A張卓琳<br />
                            3A施韻茵、3B鄧美蓮、3D盧以諾、4A徐若藍<br />
                            4A蔡梓涵、4A薛栢希、4A薛栢朗、4A邱羿潼<br />
                            4B李家佑、4C黎嘉善、4C吳凱晴、5A黃國鋒<br />
                            5B潘卓瑤、5C王嘉怡</TableCell>
                        <TableCell>Distinction</TableCell>
                        <TableCell rowspan="3">音樂智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>個人項目：<br />
                            1A何傲弦、2A顧紫睿、3B李國英、4A何    琪<br />
                            4C鍾煦柔、5A顏浩然、5B鄧凱琳、5C潘卓瑤</TableCell>
                        <TableCell>Distinction</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>個人項目：<br />
                            1B鄧宇希、2A鄭采寶、5A顏浩然、6E林子樂</TableCell>
                        <TableCell>Merit</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">58</TableCell>
                        <TableCell rowspan="2">29/3/2025</TableCell>
                        <TableCell rowspan="2">香港教育大學</TableCell>
                        <TableCell rowspan="2">五人足球邀請賽(中學組碟賽)</TableCell>
                        <TableCell>4C林煒東</TableCell>
                        <TableCell>MVP最佳球員</TableCell>
                        <TableCell rowspan="2">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 2C阮浩維、3A劉澤賢、4A何智富、4B顏浩天<br />
                            4C陳子謙、4C林煒東、4C陸梓峰、4C 唐梓豪<br />
                            4D劉善恒、5C劉澤霖、5D譚臻廷</TableCell>
                        <TableCell>冠軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>59</TableCell>
                        <TableCell>10/5/2025</TableCell>
                        <TableCell>香港業餘冰球會</TableCell>
                        <TableCell>2025    Hockey 5's _Asian C West</TableCell>
                        <TableCell>5A陸凱俊</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>60</TableCell>
                        <TableCell>6/4/2025</TableCell>
                        <TableCell>跆拳道大滿貫世青俱樂部聯賽組織委員會</TableCell>
                        <TableCell>2025年跆拳道大滿貫世青俱樂部聯賽香港站</TableCell>
                        <TableCell> 2B賴一霖</TableCell>
                        <TableCell>品勢 男子12-14歲 季軍</TableCell>
                        <TableCell rowspan="2">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>61</TableCell>
                        <TableCell>25/5/2025</TableCell>
                        <TableCell>中國香港跆拳道協會</TableCell>
                        <TableCell>第68屆體育節-跆拳道男子色帶賽2025</TableCell>
                        <TableCell> 2B賴一霖</TableCell>
                        <TableCell>男子色帶組（搏擊）亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="4">62</TableCell>
                        <TableCell rowspan="4">30/3/2025</TableCell>
                        <TableCell rowspan="4">中國香港賽艇協會</TableCell>
                        <TableCell rowspan="4">2025香港室内賽艇錦標賽暨慈善長途接力賽</TableCell>
                        <TableCell> 3C陳荔瑩</TableCell>
                        <TableCell>Women's    Pair Slide Mode 500m 殿軍<br />
                            女子14-16歲個人500米 第9名</TableCell>
                        <TableCell rowspan="4">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3B林廷軒</TableCell>
                        <TableCell>Men's    Pair Slide Mode 500m殿軍<br />
                            男子14-16歲個人500米 第5名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A吳嘉豪</TableCell>
                        <TableCell>男子14-16歲個人500米 第8名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 3A葉子樂</TableCell>
                        <TableCell>男子14-16歲個人500米 第9名</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>63</TableCell>
                        <TableCell>4月/2025</TableCell>
                        <TableCell>啟賢教育協會/<br />
                            香港資優教育專業協會/中國香港攀山及攀登總會</TableCell>
                        <TableCell>GRITeam-香港四極<br /></TableCell>
                        <TableCell>1C    陳楚淩</TableCell>
                        <TableCell>香港東極 東平洲<br />
                            香港南極 蒲台島<br />
                            香港西極 雞翼角<br />
                            香港北極 蓮麻坑<br />
                            完成4次登山，獲取《登山證書》</TableCell>
                        <TableCell>自然辨識智能/<br />
                            人際關係智能/<br />
                            內省智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="2">64</TableCell>
                        <TableCell rowspan="2">4月/2025</TableCell>
                        <TableCell rowspan="2">亞洲國際數學<br />
                            奧林匹克聯合會</TableCell>
                        <TableCell rowspan="2">2025亞洲國際數學奧林匹克公開賽<br />
                            (AIMO Open Contest)晉級賽</TableCell>
                        <TableCell>1A    徐家濠</TableCell>
                        <TableCell>中學一年級組 金獎</TableCell>
                        <TableCell rowspan="2">邏輯數學<br />
                            智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1A 吳鎧堯</TableCell>
                        <TableCell>中學一年級組 銅獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">65</TableCell>
                        <TableCell rowspan="3">4月/2025</TableCell>
                        <TableCell rowspan="3">國際評估和培育中心</TableCell>
                        <TableCell rowspan="3">ICAS數學培訓及比賽</TableCell>
                        <TableCell><br />
                            Ø	1A 徐家濠<br /></TableCell>
                        <TableCell>v	Distinction</TableCell>
                        <TableCell rowspan="3">邏輯數學<br />
                            智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 2A周梓溱、3A古豐源</TableCell>
                        <TableCell>Merit</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3A吳柏熹、4A列俊希</TableCell>
                        <TableCell> Credit</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>66</TableCell>
                        <TableCell>5月/2025</TableCell>
                        <TableCell>香港會計師公會及香港商業教育學會</TableCell>
                        <TableCell>「企會財」獎學金2024-25</TableCell>
                        <TableCell> 5A    陳駿希</TableCell>
                        <TableCell>獎學金及獎狀</TableCell>
                        <TableCell>邏輯數學智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>67</TableCell>
                        <TableCell>21/5/2025</TableCell>
                        <TableCell>屈臣氏集團</TableCell>
                        <TableCell>屈臣氏集團香港學生運動員獎 2024-2025</TableCell>
                        <TableCell> 6B周以傑<br /></TableCell>
                        <TableCell>運動員獎</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>68</TableCell>
                        <TableCell>24/5/2025</TableCell>
                        <TableCell>香港學界體育聯會 - 港島及九龍地域中學分會</TableCell>
                        <TableCell>中銀香港室內賽艇盃</TableCell>
                        <TableCell>3B林廷軒<br /></TableCell>
                        <TableCell>第8名</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="14">69</TableCell>
                        <TableCell rowspan="14">14/3/2025</TableCell>
                        <TableCell rowspan="14">博愛醫院</TableCell>
                        <TableCell rowspan="14">博愛醫院屬校第十四屆聯校運動會<br /></TableCell>
                        <TableCell> 1B梁芷寧Ø</TableCell>
                        <TableCell>女子初級組100米 季軍</TableCell>
                        <TableCell rowspan="14">身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3B黎靜  </TableCell>
                        <TableCell>女子初級組200米季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A方沛琳</TableCell>
                        <TableCell>女子初級組400米 季軍<br />
                            女子初級組800米 亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 3A蔡煒煌</TableCell>
                        <TableCell>男子初級組800米    季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A鄧家昊</TableCell>
                        <TableCell> 男子初級組擲鐵餅 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 2A吳嘉豪</TableCell>
                        <TableCell>男子初級組推鉛球    冠軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 4C林暉程</TableCell>
                        <TableCell> 男子高級組400米 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5B石俊生</TableCell>
                        <TableCell>男子高級組800米    季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>5A陳諾一</TableCell>
                        <TableCell>男子高級組1500米    季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 4B顏浩天</TableCell>
                        <TableCell>男子高級組跳高    季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4D馬崇倫</TableCell>
                        <TableCell>男子高級組跳高    季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 1A陳詩盈、1B林祉荍、1B梁芷寧、2A方沛琳、2B李坤然、2C丁郗怡、3B施  瑤、3B黎  靜</TableCell>
                        <TableCell>女子初級組4X400米接力 亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 3A葉家君、5A吳詩韻、5C陳映蕎、5E李漫淇</TableCell>
                        <TableCell>女子高級組4X100米接力    季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 1A盧昱霈、1D李京岸、3A蔡煒煌、3B黃允臻、5A陳諾一、5B石俊生、5B黃允璞、5C丁郗彥</TableCell>
                        <TableCell>男子高級組  4X400米接力 季軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>70</TableCell>
                        <TableCell>5月/2025</TableCell>
                        <TableCell>茶藝舍</TableCell>
                        <TableCell>青少年茶文化大使校際準決賽</TableCell>
                        <TableCell>3A鄭  盈、3B劉凱琳、4B陳姿霖、4B張森蕙、6A邱錦承、6B洪仟鎣</TableCell>
                        <TableCell>季軍</TableCell>
                        <TableCell>內省智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">71</TableCell>
                        <TableCell rowspan="3">6月/2025</TableCell>
                        <TableCell rowspan="3">香港學校音樂及朗誦協會 </TableCell>
                        <TableCell rowspan="3">第77屆香港學校音樂節</TableCell>
                        <TableCell>1A何傲弦、2B陳栢澄、5A溫凱翔      </TableCell>
                        <TableCell>v	鋼琴獨奏 銀獎</TableCell>
                        <TableCell rowspan="3">音樂智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2B黃焯榆、4D馬嘉怡、5B吳汶錡</TableCell>
                        <TableCell>鋼琴獨奏 銅獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>4A呂東賢 </TableCell>
                        <TableCell>小提琴獨奏 銅獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>72</TableCell>
                        <TableCell>Apr-25</TableCell>
                        <TableCell>香港青年協會</TableCell>
                        <TableCell>The    HKFYG English Public Speaking Contest 2025</TableCell>
                        <TableCell>4A林政熙</TableCell>
                        <TableCell>嘉許獎</TableCell>
                        <TableCell>語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>73</TableCell>
                        <TableCell>6月/2025</TableCell>
                        <TableCell>電影、報刊及物品管理辦事處</TableCell>
                        <TableCell>《淫褻及不雅物品管制條例》口號創作及填色比賽</TableCell>
                        <TableCell>3B張芯悅、3B呂想想、5B李紫盈、5B梁凱怡</TableCell>
                        <TableCell>優異獎</TableCell>
                        <TableCell>空間智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="6">74</TableCell>
                        <TableCell rowspan="3">Mar-25</TableCell>
                        <TableCell rowspan="6">中國青少年語言文化學會全國青少年語言文化知識大賽</TableCell>
                        <TableCell rowspan="3">菁英盃現場作文決賽</TableCell>
                        <TableCell>3B李芷璇、4A何琪<br />
                            v </TableCell>
                        <TableCell>一等獎</TableCell>
                        <TableCell rowspan="6">語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A楊雯曦、2A吳嘉豪、5A藍上鈞</TableCell>
                        <TableCell>二等獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3B鍾葦彤、3B呂想想、4B陳姿霖、4D馬嘉怡、5A許晴晴、5A葉文棟</TableCell>
                        <TableCell>三等獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell rowspan="3">May-25</TableCell>
                        <TableCell rowspan="3">菁英盃現場作文總決賽</TableCell>
                        <TableCell> 4A何琪</TableCell>
                        <TableCell> 一等獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2A吳嘉豪、3B李芷璇</TableCell>
                        <TableCell>二等獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell> 2A楊雯曦、3B鍾葦彤、3B呂想想、4B陳姿霖、4D馬嘉怡、5A許晴晴、5A葉文棟、5A藍上鈞</TableCell>
                        <TableCell>三等獎</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>75</TableCell>
                        <TableCell rowspan="2">28/6/2025</TableCell>
                        <TableCell rowspan="2">樂兒計劃成長基金</TableCell>
                        <TableCell rowspan="2">「歌唱未來，生命精彩」全港中小學音樂比賽2025</TableCell>
                        <TableCell>4C陳子謙、4D李煜珩、4D盧璨森、5C馬晉煒</TableCell>
                        <TableCell>冠軍</TableCell>
                        <TableCell rowspan="2">音樂智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>76</TableCell>
                        <TableCell>1A楊家蕙、1A張頌揚、1B鄧宇希、1B陳子曦、1D李沂樂</TableCell>
                        <TableCell>亞軍</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>77</TableCell>
                        <TableCell>10/7/2025</TableCell>
                        <TableCell>香港中華文化促進中心</TableCell>
                        <TableCell>2024-2025中國中學生作文大賽</TableCell>
                        <TableCell>3B呂想想 </TableCell>
                        <TableCell>初中組銅獎</TableCell>
                        <TableCell>語言智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>78</TableCell>
                        <TableCell>Jul-25</TableCell>
                        <TableCell>香港冰球訓練學校 (HKAIH)</TableCell>
                        <TableCell>2024 - 2025 香港校際冰球聯賽</TableCell>
                        <TableCell>5A 鍾傜羽 </TableCell>
                        <TableCell>最有價值球員 (Team MVP) </TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>79</TableCell>
                        <TableCell>30/3/2025</TableCell>
                        <TableCell>康樂及文化事務署、中國香港體育舞蹈總會</TableCell>
                        <TableCell>校際體育舞蹈錦標賽-第三級男步章別賽決賽</TableCell>
                        <TableCell>2A馮靖喬</TableCell>
                        <TableCell>單人14-15歲 牛仔舞 冠軍<br />
                            單人14-15歲 倫巴舞 冠軍<br />
                            單人14-15歲 查查查 冠軍</TableCell>
                        <TableCell>身體動覺智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>80</TableCell>
                        <TableCell>Jul-25</TableCell>
                        <TableCell>西貢文化中心、西貢區校長會、西貢將軍澳青年總會、民政總署</TableCell>
                        <TableCell>第二十四屆西貢區傑出學生<br /></TableCell>
                        <TableCell>1A廖子敬、2A鄧家昊、3A古豐源、5A孫暉喬、5A鍾傜羽、5A顏浩然</TableCell>
                        <TableCell>嘉許狀</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>81</TableCell>
                        <TableCell>Jul-25</TableCell>
                        <TableCell>香港校董會</TableCell>
                        <TableCell>大灣區優秀學生推選2025</TableCell>
                        <TableCell>2A陳嘉齊、5A許晴晴、5A陳榮錄</TableCell>
                        <TableCell>優等獎</TableCell>
                        <TableCell>多元智能</TableCell>
                    </TableRow>
                </Table>
            </TableContainer>
        </Paper>
    );

    return (
        <>
            {loading && <Skeleton variant="rectangular" sx={{ width: 1, height: '200px', }} />}
            {selectedYear !== 2024 && Object.keys(data).map((domain) => (<RenderDomain key={domain} domain={domain} />))}
            {selectedYear === 2025 && <Table2025 />}
        </>
    );
};

export default TableData;